export const SOURCES = {
    TPA: 'TPA',
    CORVID: 'CORVID',
    UNSPECIFIED: 'UNSPECIFIED'
}
